import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-about-us',
  templateUrl: './about-us.component.html',
  styleUrls: ['./about-us.component.scss']
})
export class AboutUsComponent implements OnInit {
  lat = -25.979460712525558;
  lng = 28.123178923298063;
  constructor() { }

  ngOnInit(): void {
  }

}
